
// 开发环境走同源 /api，由 vue.config.js 的 devServer.proxy 转发，避免直连线上域名触发 CORS
const baseURL = '/'

export default baseURL;